import { render, staticRenderFns } from "./FAindustry.vue?vue&type=template&id=82dfb114&scoped=true&"
import script from "./FAindustry.vue?vue&type=script&lang=js&"
export * from "./FAindustry.vue?vue&type=script&lang=js&"
import style0 from "./FAindustry.vue?vue&type=style&index=0&id=82dfb114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dfb114",
  null
  
)

export default component.exports